<template>
  <div class="notification is-success is-light">
    <button class="delete" @click="onClosed"></button>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'SuccessNotification',
  props: {
    label: String,
    onClosed: Function
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/SuccessNotification.vue